export const ont_T2001 = {
    meta_title: " Compact GPON Fiber Endpoint | Niurix T2001 ONT",
    meta_description: "Niurix T2001 ONT provides compact GPON fiber connectivity for room-level and unit-level network deployments.",

    section1: {
        background_img: "T2001 banner",
        background_img_mobile: "T2001 banner",
    },

    section2: {
        mainHeading: `<span>Our</span> Product (ONTs)`,
        subHeading: "Niurix T2001",
        para: `<p>The Niurix T2001 is a compact fiber endpoint designed for environments that require streamlined connectivity with essential services. It delivers high-speed internet, voice, and TV over a single fiber connection reducing in-room complexity while maintaining a consistent service experience.\n\nDesigned for hospitality and residential deployments, this ONT supports clean installations, efficient power usage, and simplified maintenance, making it ideal for properties focused on operational efficiency and modern interiors.</p>`,
        background_img1: "Overview background",
        background_img1_mobile: "Product T2001 backg",
    },
    section3: {
        mainHeading: `Compact<span> Triple-Play </span>Fiber Endpoint`,
        // subHeading1: "Versatility and seamless integration",
        para1: `<p>Not every deployment requires multiple LAN ports or complex in-room wiring. The Niurix T2001 focuses on essential connectivity, delivering triple-play services through a streamlined interface.\n\nBy replacing multiple copper cables with a single fiber drop, it simplifies installation, reduces maintenance overhead, and aligns with Niurix’s broader goal of clean, future-ready fiber architecture across properties.<p>`,
        subHeading2: "Simplifying Connectivity at the Edge",
        para2: `<ul><li>4 Ethernet port</li><li>1 GPON Uplink Port</li></ul>`,
        background_img: "ComponentT2001",
    },
    section4: {
        background_img: "Details",
        background_img_mobile: "details T2001",
        title: "Simplifying Connectivity at the Edge",
        text_content_groups: [
            {
                title: "Triple-Play over Fiber",
                para: "Delivers internet, voice, and TV through a single GPON fiber connection.",
            },
            {
                title: "Reduced Port Density",
                para: "2× Ethernet, 1× POTS, and 1× CATV—designed for rooms with limited device needs.",
            },
            {
                title: "Deployment-Optimized Design",
                para: "Compact form factor suited for clean, unobtrusive room installations.",
            },
        ],
    },
    section5: [
        {
            title: "General Product Specifications of T2001",
            specifications: "Specification",
            dimension: "Dimensions",
            specification: [
                {
                    title: "XGSPON Port",
                    value: "01",
                },
                {
                    title: "10GE Port",
                    value: "01",
                },
                {
                    title: "GE Port",
                    value: "01",
                },
                {
                    title: "Voice Port",
                    value: "01",
                },
                {
                    title: "Power Supply",
                    value: "12 Vdc, 1A",
                },
                {
                    title: "Operating Temperature",
                    value: "32°-122°F(0-50°C)",
                },
                {
                    title: "Power Over Internet (802.3bt)",
                    value: "Upto 90W",
                },
            ],
            dimensions: [
                {
                    title: "Length",
                    value: "156mm",
                },
                {
                    title: "Width",
                    value: "156mm",
                },
                {
                    title: "Height",
                    value: "38mm",
                },
                {
                    title: "Weight",
                    value: "< 500g",
                },
            ],
            para: "Click to download the full specifications",
            pdf: "Niurix T2001",
        },
    ],

    swipper: {
        img1: "Spec 1",
        img2: "Spec 2",
        img3: "Spec 3",
        img4: "Spec 4",
    },
    section6: {
        video: "Video",
    },
    section7: {
        background_img: "contact banner",
        title: "section5",
    },
};
